export default "/assets/window.a11604d4e834dd9562350c2a482bbb38.png";